import PropTypes from "prop-types";
import * as React from "react";
import QuickActionTile from "../templates/quickActionTile";
import SingleLinkTile from "../templates/singleLinkTile";
import { quickActionTilesMap } from "../tilesMap";
import { BENEFITS } from "../../../constants/externalUrls";

const BenefitsTile = ({ id }) => {
    return (
        <QuickActionTile id={id}>
            <SingleLinkTile
                link={BENEFITS}
                linkText={quickActionTilesMap[id].description}
                title={"SSE Benefits"}
            />
        </QuickActionTile>
    );
};

BenefitsTile.propTypes = {
    id: PropTypes.string.isRequired,
};

export default BenefitsTile;
